import { useCallback } from 'react';

import * as Types from './types';
import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';

export const useGetQuickDepositConfiguration = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IQuickDepositConfigurationResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IQuickDepositConfigurationResponseData>({
            ID: 35853,
            responses: [35854, 35855],
            description: 'Get Quick Deposit Configuration',
            errorLevel: 1
        });

        return data;
    }, [
        send
    ]);
};
